module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAQZJREFUWEftl+ENgjAQhR+buIneJjKJbiJO8nAS3UTzSEuKMdijRGLSSwj8aHtfX9+VtsHG0XjykzwA2AF46DEzvYvCC0AAglC0ZtYVZQfw3wAA+rAkOUJ8XLIiBQDsARxzsoc2AtbSjd75NUBkHf1TCqABLw4F0qZnANcJAEmV2Ck4Xd9z0YZyVGUsjW4ECDXuGWyQkeRzaXb5YQAgqVlLEk9EgLujEuL4MqH69w3JdHNZAuDt35uZxUQCkIk8pTRxclAv7o5zE9Csb++7Z7oEgvhmvDTBultxMKHUyIVYFyCY0VWG9WdUFagKVAWqAlWBqsAWCsTLKdZIriOA617gOTDmtn0BI9ew9xl4UdkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/address.png
// module id = +RXA
// module chunks = 1